import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import QuotesLogger from 'quotes-ui-lib/tracking/quotesLogger';
import { getIsPublished } from 'quotes-ui-lib/utils/status';
import { getQuoteDetailsUrl } from 'quotes-ui-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const DetailsButton = ({
  quote,
  trackingLocation
}) => {
  const trackAction = action => {
    QuotesLogger.log('quoteInteraction', {
      action,
      location: trackingLocation
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "details-btn",
    "data-selenium-test": "details-btn",
    use: "tertiary-light",
    responsive: false,
    size: "extra-small",
    href: getQuoteDetailsUrl(quote),
    onClick: () => trackAction('Click details button'),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.details.buttonText"
    })
  }, "detailsButton");
};
export default DetailsButton;
export const showDetailsButton = quote => {
  return getIsPublished(quote);
};